import React, { Fragment, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PrintableInputOutput } from './components'
import { useReactToPrint } from 'react-to-print'
import PrintTwoToneIcon from '@mui/icons-material/PrintTwoTone'
import { cancelPrintAction, printAction } from '../../../../utils/actions'
import { Button, PrintWrapper } from '../../../../components'
import { APP_CONFIG } from '../../common/constants'
import { selectIsValidOutput } from '../../store/slices/output.slice'

const PrintView = () => {
  const printRef = useRef()
  const dispatch = useDispatch()
  const [isPrinting, setIsPrinting] = useState(false)

  const isValid = useSelector(selectIsValidOutput)

  const handlePrintAction = useReactToPrint({
    documentTitle: APP_CONFIG.appName,
    content: () => printRef.current,
    onBeforeGetContent: async () => {
      dispatch(printAction())
      setIsPrinting(true)
    },
    onAfterPrint: () => {
      dispatch(cancelPrintAction())
      setIsPrinting(false)
    },
  })

  return (
    <Fragment>
      <Button
        variant="topNav"
        className="button topNav__button"
        onClick={handlePrintAction}
        disabled={!isValid}
      >
        <PrintTwoToneIcon className="material-icons-two-tone material-icons-two-tone--noinvert" />
        <span className="button__text">Print</span>
      </Button>
      <PrintWrapper ref={printRef}>
        <div className="print-header">
          <div className="appBrandingGroup">
            <img data-src={APP_CONFIG.logoUrl} className="iconic injectSVG appLogo" alt="TBD Logo" />
            <div className="aboutAppHeading">
              <div className="aboutAppAcronym">
                <span className="aboutAppAcronym__label" />
                {APP_CONFIG.appCode}
              </div>
              <div className="aboutAppFullName">{APP_CONFIG.appName}</div>
            </div>
          </div>
        </div>
        <div className="print-body">
          {isValid && isPrinting && (
            <section className="print-modal">
              <PrintableInputOutput />
            </section>
          )}
        </div>
      </PrintWrapper>
    </Fragment>
  )
}

export default PrintView
